import DefaultExceptionEventData from './exception-event-data/DefaultEvent.mjs';
import AxiosExceptionEventData from './exception-event-data/AxiosEvent.mjs';

function beforeSend(event, hint) {
  const eventData = eventDataFactory(event, hint);
  return editEvent(event, eventData);
}
function eventDataFactory(event, hint) {
  if (AxiosExceptionEventData.isAxiosErrorHint(hint)) {
    return new AxiosExceptionEventData(event, hint);
  }
  return new DefaultExceptionEventData(event);
}
function editEvent(event, data) {
  const originExceptionList = event.exception?.values;
  const titleException = originExceptionList?.[originExceptionList.length - 1];
  if (titleException) {
    titleException.type = data.getType();
    titleException.value = data.getValue();
  }
  return {
    ...event,
    level: data.getLevel(),
    fingerprint: data.getFingerPrint(),
    exception: event.exception,
    extra: { ...data.getExtra(), ...event.extra },
    // Next Server Side 이슈 해소를 위해 request header 제거
    request: {
      ...event.request,
      ...event.request?.headers ? {
        headers: Object.fromEntries(
          Object.entries(event.request.headers).filter(
            ([key]) => ["user-agent"].includes(key.toLowerCase())
          )
        )
      } : {}
    }
  };
}

export { beforeSend as default };
//# sourceMappingURL=beforeSend.mjs.map
